import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaCircleInfo } from "react-icons/fa6";
import Select from "react-select";
import { useSelector } from "react-redux";
import groupService from "../../services/groupService";
import { toast } from "react-toastify";
import "./CreateGroupModal.css";
import { clientUrlOptions } from "../../Utils/constants";

const ExportModal = ({ show, setShowExportPopup, selectedGroupName }) => {
  const [clientToken, setClientToken] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [clientUrl, setClientUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const currentUrl = `${window.location.protocol}//${window.location.host}/`;

  // Get the authToken from Redux store
  const authToken = useSelector((state) => state.auth.token);

  const handleClose = () => {
    setShowExportPopup(false);
    setClientToken("");
    setClientSecret("");
    setClientUrl(null);
  };

  const handleExport = async () => {
    if (!clientToken || !clientSecret || !clientUrl) {
      toast.error("All fields are required.");
      return;
    }

    setLoading(true);

    const payload = {
      token: clientToken,
      secret: clientSecret,
      name: selectedGroupName,
      url: clientUrl.value,
      auth: authToken,
    };

    try {
      const response = await groupService.exportGroup(payload);

      if (response.status === 200) {
        toast.success("Export successful");
        handleClose();
      } else {
        // Handle non-successful status codes
        const apiError = response.data?.error;
        toast.error(apiError || "Export failed. Please try again.");
      }
    } catch (err) {
      // Handle network or unexpected errors
      console.error("Export failed:", err);

      const errorMessage =
        err.response?.data?.error || "Something went wrong. Please try again.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} className="create-export-modal">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>
          Export {selectedGroupName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <p>
            <FaCircleInfo style={{ marginRight: "8px" }} /> Enter Client Token
          </p>
          <Form.Control
            type="text"
            value={clientToken}
            onChange={(e) => setClientToken(e.target.value)}
            className="mb-3"
          />
          <p>
            <FaCircleInfo style={{ marginRight: "8px" }} /> Enter Client Secret
          </p>
          <Form.Control
            type="text"
            value={clientSecret}
            onChange={(e) => setClientSecret(e.target.value)}
            className="mb-3"
          />
          <p>
            <FaCircleInfo style={{ marginRight: "8px" }} /> Select Client URL
          </p>
          <Select
            value={clientUrl}
            onChange={setClientUrl}
            options={clientUrlOptions.filter(
              (option) => option.value !== currentUrl
            )}
            placeholder="Select a Client URL"
            className="mb-3"
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleExport}
          className="create-button"
          disabled={loading} // Disable the button if loading
        >
          {loading ? "Exporting..." : "Export"}
        </Button>
        <Button
          variant="secondary"
          onClick={handleClose}
          className="cancell-button cancell-button-container"
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExportModal;
